import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import '@mantine/charts/styles.css';
import { Title } from '../../components/Title';
import { OrderRow } from './components/OrderRow';
import type { OrderDto } from './types/OrderDto';
import { KeyedRow } from '../../components/KeyedRow';

export function Orders() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const ordersQuery = queryWithFilterAndPages<OrderDto[]>(
		`${organisation}/orders/all`,
		filter.value,
		pagination.value,
	);

	const eodLogsCountQuery = queryWithFilter<number>(
		`${organisation}/orders/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Orders'} filter={filter} filterOnSameLine />
			<DataTable
				pagination={pagination}
				totalItems={eodLogsCountQuery.data?.value ?? 100}
				isRowsLoading={ordersQuery.isLoading}
				isPaginationLoading={eodLogsCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Date Created'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Order No.'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Created By'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Total Net'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Order Status'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Date Received'} />
						</Table.Th>
						<Table.Th>
							<Title label={'View'} />
						</Table.Th>
						<Table.Th />
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{ordersQuery.data?.value.map((order) => (
						<OrderRow order={order} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
